/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, createElement } from 'react';

import { cardFromNumber } from '../../utils/creditCards';
import { creditCardNumberFilter } from '../../utils/creditCardFilters';
import CreditCardBrandMapping from '../../constants/CreditCardBrandMapping';
import Field from '../forms/Field';
import TextInput from '../inputs/DeprecatedTextInput';

interface Props {
  autoComplete?: boolean;
  'data-testid'?: string;
  disabled?: boolean;
  label?: string;
  id?: string;
  field: ReduxFormField<string>;
}

/**
 * @deprecated Prefer a Pantry component instead. See https://docs.tocktix.com/pantry.
 * If an equivalent component doesn't exist yet, reach out in #pantry-design-system on Slack.
 */
export default class CreditCardNumberInput extends Component<Props> {
  render() {
    const { autoComplete, disabled, field, label, id } = this.props;

    const card = cardFromNumber(field.value);
    if (!card) {
      throw new Error('unknown card');
    }

    const { component } = (CreditCardBrandMapping as any)[card.type];
    let creditCardIcon;

    if (field.value) {
      creditCardIcon = createElement(component, {
        contextClassName: 'TextInput-creditCardIcon',
      });
    }

    return (
      <Field field={field} label={label} labelFor={id}>
        <TextInput
          id={id}
          autoComplete={autoComplete ? 'cc-number' : 'off'}
          data-testid={this.props['data-testid']}
          autoCorrect="off"
          disabled={disabled}
          field={field}
          filter={creditCardNumberFilter}
          maxLength={20}
          pattern="\d*"
          type="tel"
          placeholder="Card number"
          postfix={creditCardIcon}
        />
      </Field>
    );
  }
}
